// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"357":"487e9ca9","554":"4f97452f","656":"9a6f7177","825":"0983e0a4"}[chunkId] + ".chunk.css";
};